import Pubnub from 'pubnub';
import LocalPubNubFake from './localPubNub.fake';

export const createPubNubClient = ({
  publishKey,
  subscribeKey,
  uuid,
}: {
  publishKey?: string;
  subscribeKey?: string;
  uuid: string;
}) =>
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_TECO_LOCAL_MODE === 'true'
    ? (new LocalPubNubFake({ uuid }) as unknown as Pubnub)
    : new Pubnub({ publishKey, subscribeKey: subscribeKey || '', uuid });
